module.exports = __webpack_public_path__ + "static/media/display-3.9dba80e1.png";